import api from '../utils/httpClient';
import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';


import { EmptyDataForDevice, NucleusDataForDevice } from '@nucleus-care/nucleuscare-data-types';

interface DeviceCoordinate {
  deviceId: string
  latitude: string
  longitude: string
}

interface HardwareInfo {
  deviceId: string
  info: string
}

interface DeviceControllerInfo {
  DeviceID: string;
  Version: string;
  OS: string;
  DeviceInfo:string;
}

interface DeviceStateInfo {
  DeviceID: string;
  Battery: string | number;
}

export const updateDeviceHardwareInfo = (payload: HardwareInfo) => {
  console.log('updateDeviceHardwareInfo params', payload);
  return api.post(
    `/device/${payload.deviceId}/hardware_info`,
    {
      info: payload.info
    }
  )
  .then(() =>{ console.log("updateDeviceHardwareInfo response");})
  .catch((e:any) => console.warn("updateDeviceHardwareInfo error", e));
}

export const updateDeviceControllerInfo = (payload: DeviceControllerInfo) => {
  console.log('updateDeviceControllerInfo params', payload);
  return api.put(
    `/device/${payload.DeviceID}/device_info`,
    {
      Version : payload.Version,
      OS: payload.OS,
      DeviceInfo : payload.DeviceInfo
    }
  )
  .then(() =>{ console.log("updateDeviceControllerInfo response");})
  .catch((e:any) => console.warn("updateDeviceControllerInfo error", e));
}

export const updateDeviceStateInfo = (payload: DeviceStateInfo) => {
  console.log('updateDeviceStateInfo params', payload);
  return api.put(
    `/device/${payload.DeviceID}/device_state`,
    {
      Battery : payload.Battery
    }
  )
  .then(() =>{ console.log("updateDeviceStateInfo response");})
  .catch((e:any) => console.warn("updateDeviceStateInfo error", e));
}

export const updateDevicePosition = (coordinate: DeviceCoordinate, callback: any) : Promise<any> => {
  console.log('updateDevicePosition params', coordinate);
  return api.put(
    `/device/${coordinate.deviceId}/position`,
    {
      latitude: coordinate.latitude,
      longitude: coordinate.longitude
    }
  )
  .then((response:any) =>{
    console.log("updateDevicePosition response:", response);
    callback && callback(response);
  })
  .catch((e:any) => console.warn("could not update DevicePosition", e));;
}


// DEPRECATED, Not Used
// Separated into controller info and state
// export const updateDeviceInfo = (payload: DeviceInfo) => {
//   console.log('updateDeviceInfo payload', payload);
//   const dataParams = {
// 		MacAddress: payload.MacAddress,
//     Version: payload.Version,
//     OS : payload.OS,
//     SKU : payload.SKU,
//     Shell : payload.Shell,
//     Battery: payload.Battery,
//     DeviceInfo : payload.DeviceInfo,
//     Humidity : payload.Humidity,
//     Temp : payload.Temp
// 	};
//   console.log('updateDeviceInfo params', dataParams);
//   return api.post(
//     `/device/${payload.deviceId}/device-info`,
//     dataParams
//   )
//   .then((response:any) =>{ console.log("updateDeviceInfo response:", response);})
//   .catch((e:any) => console.warn("could not update DeviceInfo", e.message));
// }


export const getDeviceIdBySerialNumber = (serialNumber:string, callback:any) : Promise<any> => {
  console.log('getDeviceIdBySerialNumber params', serialNumber);
  return api.get(
    `/device/fetchDeviceId/${serialNumber}`,
    {
      timeout: 30000,
    }
  )
  .then((response:any) =>{
    console.log("getDeviceIdBySerialNumber response:", response);
    callback && callback(response);
  })
  .catch((e:any) => {
    console.warn("getDeviceIdBySerialNumber error", e)
    callback && callback({
      ok: false,
      error: e
    });
  });
}

export const fetchDeviceInfo = createAsyncThunk(
	'deviceData/fetchDeviceInfo',
	async (deviceId: string) => {
	  console.log('fetchDeviceInfo NODE.JS params', deviceId);
	  const response = await api.get(
	    `device/${deviceId}/data_for_device`,
	    {
		    timeout: 30000,
	    }
    );
	  console.log('fetchDeviceInfo NODE.JS response', response.data);
	  return response.data;
	}
);

export const fetchDeviceInfoSerialNumber = createAsyncThunk(
	'deviceData/fetchDeviceInfoSerialNumber',
	async (serialNumber: string) => {
	  console.log('fetchDeviceInfoSerialNumber NODE.JS params', serialNumber);
	  const response = await api.get(
	    `device/${serialNumber}/data_for_device_sn`,
	    {
		    timeout: 30000,
	    }
    );
	  console.log('fetchDeviceInfoSerialNumber NODE.JS response', response.data);
	  return response.data;
	}
);

const initialState: DeviceState = {
  loading: false,
  complete:false,
  error: '',
  data: EmptyDataForDevice,
};

type DeviceState = {
  loading: boolean;
  complete: boolean;
  error?: string;
  data: NucleusDataForDevice;
}

const deviceSlice = createSlice({
  name: 'deviceData',
  initialState: initialState,
  reducers: {
      deviceSliceClean(state: DeviceState) {
        state.loading = false;
        state.complete = false;
        state.error = '';
    },
  },
  extraReducers: (builder:any) => {

      //fetchDeviceInfo
      builder.addCase(fetchDeviceInfo.pending, (state:DeviceState) => {

          state.loading = true;
          state.complete = false;
          state.error = '';
      });
      builder.addCase(fetchDeviceInfo.fulfilled, (state:DeviceState, action:any) => {

        state = { 
          ...state, 
          ...action.payload
        };
          state.loading = false;
          state.complete = true;
      });
      builder.addCase(fetchDeviceInfo.rejected, (state:DeviceState, action:any) => {
          state = { 
            ...state, 
            ...action.payload
          };
          state.loading = false;
          state.complete = false;
          state.error = action.error ? action.error.message! : '';
      });

      builder.addCase(fetchDeviceInfoSerialNumber.pending, (state:any) => {
          state.loading = true;
          state.complete = false;
          state.error = '';
      });
      builder.addCase(fetchDeviceInfoSerialNumber.fulfilled, (state:any, action:any) => {
        state = { 
          ...state, 
          ...action.payload
        };
          state.loading = false;
          state.complete = true;
      });
      builder.addCase(fetchDeviceInfoSerialNumber.rejected, (state:any, action:any) => {
        state = { 
          ...state, 
          ...action.payload
        };
          state.loading = false;
          state.complete = false;
          state.error = action.error ? action.error.message! : '';
      });
  }
});

export const { deviceSliceClean } = deviceSlice.actions;
export default deviceSlice;
